module.exports = __webpack_public_path__ + "static/media/sf-cover.7dc3040b.webp";